export const debounceUpdateWorkflow = {
  namespaced: true,
  state: {
    updateWorkflowInProgress: false
  },
  mutations: {
    updateWorkflowInProgress (state, status) {
      state.updateWorkflowInProgress = status
    }
  },
  actions: {
    async debounceUpdateWorkflow ({ commit, state }, { fn, args }) {
      if (state.updateWorkflowInProgress) {
        return
      }
      commit('updateWorkflowInProgress', true)
      try {
        await fn(...args)
      } finally {
        commit('updateWorkflowInProgress', false)
      }
    }
  }
}
